import Popover from 'antd-mobile/lib/popover';
export default Popover;



// WEBPACK FOOTER //
// ./components/popover/index.tsx